import React, { useEffect } from 'react';
import { useFlag } from '@/context/FeatureFlagsContext';
import { EventNames, FEATURE_FLAGS, HotjarEventNames } from '@/constants';
import { useEventLogger } from '@/utilities/analyticsHelper';
import { event as hotjarEvent } from '@/utilities/hotjarHelper';
import UniversalLanding from '../UniversalLanding';
import Welcome from '../MemberEnrollment/Welcome';

const Landing: React.FC = () => {
  const serveUniversalLandingPage = useFlag(FEATURE_FLAGS.ENT_UNIVERSAL_LANDING_PAGE_FLAG.key);
  const logger = useEventLogger();

  useEffect(() => {
    logger({
      name: EventNames.TEST_EXPOSURE,
      data: {
        screen_name: serveUniversalLandingPage
          ? 'Universal Landing Page'
          : '	Enterprise Member Enrollment Welcome Page',
        test_name: FEATURE_FLAGS.ENT_UNIVERSAL_LANDING_PAGE_FLAG.key,
        test_variant: serveUniversalLandingPage ? 'Test' : 'Control',
      },
    });

    hotjarEvent(
      serveUniversalLandingPage ? HotjarEventNames.ULP_VIEWED : HotjarEventNames.WELCOME_PAGE_VIEWED
    );
  }, []);

  if (serveUniversalLandingPage) {
    return <UniversalLanding />;
  }

  return <Welcome />;
};

export default Landing;
